<template>
    <div class="sync-page">
        <div v-if="mainShow">
            <back
                :is-router="true"
                url="/mng/weworkAccount/index"
            >
                企业微信账号
            </back>
            <content-title>配置代开发应用</content-title>
        </div>
        <div v-if="installShow">
            <h2 class="content-title">
                企业微信账号
            </h2>
            <v-steps
                :titles="stepTitles"
                :index="currStepIndex"
            />
        </div>
        <instead-auth
            :is-last-step="true"
            @success="onSuccess"
        />
    </div>
</template>

<script>
import Gateway from '@/utils/Gateway';
import setFlowNext from '@/pages/mng/third_account/weworkCombine/api/setFlowNext';
import Back from '@/components/back';
import InsteadAuth from '../../instead-auth';
import ContentTitle from '../../content-title';

export default {
    components: {
        Back,
        InsteadAuth,
        ContentTitle,
    },

    data() {
        return {
            hasSyncStep: false,
            mainShow: false,
            installShow: false,
            stepTitles: ['授权安装应用', '授权通讯录'],
            currStepIndex: 2,
            hasInstallStep: false,
        };
    },

    created() {
        this.getFlowState();
    },

    methods: {
        getFlowState() {
            Gateway.get('/v1/basic/corp/wework/flowState')
                .then((data) => {
                    const { current, catalogue } = data || {};

                    if (current == 'main') {
                        this.mainShow = true;
                    } else if (current == 'install_app') {
                        this.installShow = true;
                        this.hasInstallStep = true;
                    }

                    if (catalogue && catalogue.includes('sync')) {
                        this.hasSyncStep = true;
                    }
                })
                .catch((msg) => {
                    this.$message.error(msg || '获取flowState失败');
                });
        },
        onSuccess() {
            if (this.hasSyncStep) {
                this.$router.push('/mng/weworkAccount/index/sync/add');
            } else if (this.hasInstallStep) {
                this.$router.push('/mng/weworkAccount/index');
            } else {
                setFlowNext('authorize')
                    .then(() => {
                        this.$router.push('/mng/weworkAccount/index');
                    })
                    .catch((msg) => {
                        this.$message.error(msg);
                    });
            }
        },
    },
};
</script>
